// src/components/Settings/Layout/SecuritySettings.js

import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import SecuritySelector from "../Utils/SecuritySelector";
import { ThemeContext } from "../../../../../context/ThemeContext";

const SecuritySettings = () => {
  const [securityPolicyAccepted, setSecurityPolicyAccepted] = useState(false);
  const { theme } = useContext(ThemeContext);

  useEffect(() => {
    import(`../Styles/themes/${theme}/themes.css`)
      .then(() => console.log(`Loaded ${theme} styles for SecuritySettings`))
      .catch(() => console.error(`Theme CSS not found for ${theme}`));
  }, [theme]);

  return (
    <div className="st-panel sec-root">
      <h2 className="st-panel-title">🔐 Security Settings</h2>
      <p className="st-panel-subtitle">Customize your account security preferences and protection measures.</p>

      {/* Master Toggle */}
      <div className="sec-master-toggle">
        <div className="sec-master-toggle-info">
          <span className="sec-master-toggle-title">
            {securityPolicyAccepted ? "✅ Security Customization Active" : "Configure Security Settings"}
          </span>
          <span className="sec-master-toggle-desc">
            {securityPolicyAccepted
              ? "Your custom security settings are active. Adjust them below."
              : "Enable to customize advanced security options for your account."}
          </span>
        </div>
        <label className="st-switch">
          <input
            type="checkbox"
            checked={securityPolicyAccepted}
            onChange={() => setSecurityPolicyAccepted(!securityPolicyAccepted)}
          />
          <span className="st-slider" />
        </label>
      </div>

      {/* Security Selector Component */}
      {securityPolicyAccepted && (
        <div className="sec-content">
          <SecuritySelector />
        </div>
      )}

      {/* Info Banner */}
      {!securityPolicyAccepted && (
        <div className="sec-info-banner" style={{background: "rgba(36,36,45,0.2)", border: "1px solid gray"}}>
          <span>ℹ️</span>
          <p>
            Enable the toggle above to customize advanced security settings. You can configure
            two-factor authentication, login notifications, and other protection mechanisms.{" "}
            <Link to="/security-info" className="sec-link">Learn more</Link>
          </p>
        </div>
      )}
    </div>
  );
};

export default SecuritySettings;
